module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_9-2a19a50e8d1e7784206355313541ac56.png";